import React, { FC } from 'react'
import cx from 'classnames'

type AuroraSpinnerProps = React.SVGProps<SVGSVGElement>

export const AuroraSpinner: FC<AuroraSpinnerProps> = ({
  width,
  height,
  fill,
  className,
}) => {
  return (
    <svg
      className={cx('animate-spin-slow', className)}
      width={width || '24'}
      height={height || '24'}
      viewBox="0 0 24 24"
      fill={fill || 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM3.6 12C3.6 16.6392 7.36081 20.4 12 20.4C16.6392 20.4 20.4 16.6392 20.4 12C20.4 7.36081 16.6392 3.6 12 3.6C7.36081 3.6 3.6 7.36081 3.6 12Z"
        fill="url(#paint0_linear_403_555)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_403_555"
          x1="-2.19443e-08"
          y1="8.10218"
          x2="24"
          y2="15.8978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005397" />
          <stop offset="1" stopColor="#00C9BF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
